export const ONLY_XLSX = "Only *.xlsx files are accepted.";

// Called from onDropRejected — maps dropzone error codes to friendly messages
export function getDropRejectionError(failedFiles) {
  const code = failedFiles?.[0]?.errors?.[0]?.code;
  switch (code) {
    case "file-invalid-type":
      return ONLY_XLSX;
    default:
      return "The file could not be uploaded.";
  }
}
